import { createFileRoute } from "@tanstack/react-router";
import { NewVesselPage } from "~/pages/vessels/NewVesselPage";

export const Route = createFileRoute("/_authenticated/vessels/new")({
  component: NewVesselPage,
});
